import React, { ReactNode, createContext, useContext, useState } from 'react';
import { useSavedFilters, SavedFiltersReturnType } from './savedFilters.hook';
import { FilterContext } from '@ecosystem/newron-client-lib';

type SavedFiltersContextType = SavedFiltersReturnType & {
  newFilterId: string;
  setNewFilterId: (filterId: string) => void;
};

const savedFiltersContext = createContext<SavedFiltersContextType>(null);

type SavedFiltersProviderProps = {
  filterContext: FilterContext;
  children: ReactNode;
};

function SavedFiltersProvider({ filterContext, children }: SavedFiltersProviderProps) {
  const currentContext = useSavedFilters(filterContext);
  const [newFilterId, setNewFilterId] = useState<string>();

  return (
    <savedFiltersContext.Provider value={{ ...currentContext, newFilterId, setNewFilterId }}>
      {children}
    </savedFiltersContext.Provider>
  );
}

function useSavedFiltersContext() {
  const context = useContext(savedFiltersContext);

  return { saveFilterEnabled: !!context, ...(context ?? {}) };
}

export { SavedFiltersProvider, useSavedFiltersContext };
